/* How well a talent answered the brief, as the table shows it.
 *
 * The API runs one funnel per job — level, then specialty, then tools, then
 * skills — and stores on each matched row the deepest step that talent
 * personally survived (`match_depth`): 2 specialty, 3 tools, 4 skills.
 *
 * The list is the widest pool that had enough people in it, so it mixes
 * talents who got to different depths. Without a rank they all look equally
 * matched and the fullest matches are buried.
 */

export const MAX_STARS = 3;

/** 1 star specialty, 2 tools, 3 skills. 0 when the row predates the ranking. */
export const matchStars = (matched) => {
  const depth = Number(matched?.match_depth ?? 0);
  if (!Number.isFinite(depth) || depth < 2) return 0;
  return Math.min(MAX_STARS, depth - 1);
};

export const MATCH_LABELS = {
  0: 'Matched on role and level',
  1: 'Matched the specialty',
  2: 'Matched the specialty and tools',
  3: 'Matched the specialty, tools and skills',
};

export const matchLabel = (matched) => MATCH_LABELS[matchStars(matched)] ?? MATCH_LABELS[0];

/**
 * The talent's own level, to show under their name.
 *
 * A job now reaches its whole band — an L3 posting matches L3, L4 and L5 —
 * so the people in one list are no longer all at the same level.
 */
export const talentLevel = (matched) => matched?.matchedTalentUser?.userCbtLevel?.level_name ?? '';

/** Rank first, so the fullest matches sit at the top of the list. */
export const byMatchRank = (a, b) => matchStars(b) - matchStars(a);
